import { keys } from '../../../utilities';
import { queryOnScope, active, toArray, } from '../../useFocusTrap/internal/utils';
// Excluded: input[type=text], select, textarea, [contenteditable]
const focusableElements = [
    'input[type=button]:not([disabled])',
    'input[type=checkbox]:not([disabled])',
    'input[type=radio]:not([disabled])',
    'input[type=file]:not([disabled])',
    'input[type=reset]:not([disabled])',
    'input[type=submit]:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]:not([disabled]):not([aria-disabled=true]):not(input):not(textarea):not(select)',
];
export const focusableSelector = focusableElements
    .map((s) => s + ':not([hidden]):not([contenteditable])')
    .join(',');
export { active, queryOnScope };
export const getScope = (scope) => {
    if (!scope)
        return null;
    return toArray(scope)
        .map((el) => { var _a; return (_a = el.current) !== null && _a !== void 0 ? _a : el; })
        .filter((el) => el instanceof HTMLElement);
};
export const isInsideScope = (scope, el, keynavId) => {
    const scopeElement = scope.find((item) => (item === null || item === void 0 ? void 0 : item.contains(el)) &&
        isInsideSameKeynav(el, keynavId));
    return !!scopeElement;
};
export const getFocusables = (scope, selectorOptions, tabLoop, key, keynavId) => {
    const selector = getSelector(selectorOptions);
    const focusables = queryOnScope(scope, selector).filter((el) => isInsideSameKeynav(el, keynavId));
    const result = {
        active: null,
        next: null,
    };
    const current = focusables === null || focusables === void 0 ? void 0 : focusables.indexOf(active());
    if (!focusables || current < 0)
        return result;
    result.active = focusables[current];
    result.next = focusables[nextIdx(focusables, tabLoop, key)];
    return result;
};
// Trims commas and whitespaces
const trim = (str) => {
    let result = str, prevResult = '';
    do {
        prevResult = result;
        result = result.trim().replace(/(^,)|(,$)/, '');
    } while (result !== prevResult);
    return result;
};
const isSelectorValid = (selector) => {
    const queryCheck = (s) => document.createDocumentFragment().querySelector(s);
    try {
        queryCheck(selector);
    }
    catch (_a) {
        return false;
    }
    return true;
};
export const getSelector = (selectorOptions) => {
    const { selector, extendSelector = '' } = selectorOptions;
    let result;
    if (selector) {
        result = trim(selector);
    }
    else {
        result = trim(focusableSelector + ',' + trim(extendSelector));
    }
    if (isSelectorValid(result))
        return result;
    console.warn('@servicetitan/design-system: useKeyNav() provided with invalid `selectorOptions`', result);
    return focusableSelector;
};
const nextIdx = (focusables, loop, key) => {
    const current = focusables === null || focusables === void 0 ? void 0 : focusables.indexOf(active());
    const last = (focusables === null || focusables === void 0 ? void 0 : focusables.length) - 1;
    if (key === keys.home)
        return 0;
    if (key === keys.end)
        return last;
    if ([keys.down, keys.right].includes(key)) {
        if (current === last)
            return loop ? 0 : last;
        return current + 1;
    }
    if ([keys.up, keys.left].includes(key)) {
        if (current === 0)
            return loop ? last : 0;
        return current - 1;
    }
};
export const createId = () => {
    const res = Math.round(Math.random() * 0xffffff).toString(16);
    return res;
};
export const isInsideSameKeynav = (el, keynavId) => {
    var _a;
    const closest = el.closest('[data-keynav]');
    return keynavId === ((_a = closest === null || closest === void 0 ? void 0 : closest.dataset) === null || _a === void 0 ? void 0 : _a.keynav);
};
//# sourceMappingURL=utils.js.map